import { type PayoutPaymentChannel, type PayoutTraderConfig } from '~/entities/payout';

const getPaymentChannelWithDefaults = (channel: PayoutPaymentChannel): PayoutPaymentChannel => ({
    ...channel,
    filter: {
        ...channel.filter,
        bankCodes: {
            allowed: channel.filter?.bankCodes?.allowed ?? [],
            forbidden: channel.filter?.bankCodes?.forbidden ?? [],
        },
    },
});

export const getConfigWithDefaults = (config?: PayoutTraderConfig): PayoutTraderConfig => {
    const { acceptRateLimit, limits, minSplitChildAmount, paymentChannels, ...configValues } = config ?? {};

    return {
        canSplitOrder: false,
        ...configValues,
        acceptRateLimit: {
            maxAccepts: acceptRateLimit?.maxAccepts ?? '',
            windowSeconds: acceptRateLimit?.windowSeconds ?? '',
        },
        limits: {
            allDay: {
                value: limits?.allDay?.value ?? '',
            },
            day: {
                value: limits?.day?.value ?? '',
            },
            night: {
                value: limits?.night?.value ?? '',
            },
            useAllDay: limits?.useAllDay ?? false,
        },
        minSplitChildAmount: {
            value: minSplitChildAmount?.value ?? '0',
        },
        paymentChannels: (paymentChannels ?? []).map(getPaymentChannelWithDefaults),
    };
};
